import { toast } from "react-toastify";
import Loader from "src/components/common/Loader/Loader";
import { usePutRegularClassSchedulesSimulate } from "src/services/react-query-apis/put-regular-class-schedules-simulate";
import { usePutRegularClassSchedules } from "src/services/react-query-apis/put-regular-class-schedules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from "antd";
import RescheduleAttendanceWarning from "src/components/admin/masterMaintenance/time-table-master/reschedule-attendance-warning";
import DataChanges from "src/components/common/update-confirmation/data-changes";

const TimeTableUpdateConfirm = ({ updatePayload, onClose, onBack }) => {
  const putRegularClassSchedulesSimulateQuery =
    usePutRegularClassSchedulesSimulate({
      ...updatePayload,
      queryConfig: {
        staleTime: 0,
      },
    });

  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      setTimeout(() => {
        onClose();
      }, 1000);
    },
  };

  const putRegularClassSchedulesMutation = usePutRegularClassSchedules({
    mutationConfig,
  });

  if (putRegularClassSchedulesSimulateQuery.isFetching) {
    return <Loader message="データを取得中..." />;
  }

  if (putRegularClassSchedulesSimulateQuery.isError) {
    return (
      <>
        <div className="text-danger text-center mb-3 p-1 rounded bg-light border fw-bold">
          {putRegularClassSchedulesSimulateQuery.error.response.data.message}
        </div>
        <div className="text-end">
          <button className="btn btn-primary" onClick={onBack}>
            戻る
          </button>
        </div>
      </>
    );
  }

  const { schedule_changes, member_class_changes } =
    putRegularClassSchedulesSimulateQuery.data?.data || {};

  const membersWithErrors = member_class_changes.errors;
  const membersWithChanges = member_class_changes.successes;

  const hasErrors = membersWithErrors.length > 0;

  const columns = [
    {
      title: "会員コード",
      dataIndex: "member_code",
      key: "member_code",
    },
    {
      title: "会員名",
      dataIndex: "member_name",
      key: "member_name",
    },
  ];

  const dataSource = membersWithChanges.map(({ member_code, member_name }) => ({
    key: member_code,
    member_code,
    member_name,
  }));

  const rescheduleAttendances =
    putRegularClassSchedulesSimulateQuery.data?.data
      .affected_rescheduled_attendances || [];

  const hasRescheduleAttendances = rescheduleAttendances.length > 0;

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column w-100 time-table-form">
        <div className="mb-4">
          <h6 className="text-center mb-3">スケジュール変更の確認</h6>
          <div className="d-flex flex-column gap-3">
            <div className="day-label text-center mb-3 p-1 rounded bg-light border fw-bold">
              {updatePayload.day_week}
            </div>
            <DataChanges changes={schedule_changes} />
          </div>
        </div>

        <div className="mb-4">
          <h6 className="text-center mb-3">
            影響を受ける会員のスケジュール ({membersWithChanges.length}名)
          </h6>
          <Table
            columns={columns}
            dataSource={dataSource}
            size="small"
            pagination={false}
            bordered
            locale={{
              emptyText: "影響を受ける会員はいません",
            }}
          />
        </div>

        {hasErrors && (
          <div className="mb-4">
            <h6 className="text-center mb-3 text-danger">
              エラーが発生した会員 ({membersWithErrors.length}名)
            </h6>
            <div className="alert alert-danger mb-0">
              <div className="d-flex flex-column gap-2">
                {membersWithErrors.map(({ member_id, member_code, error }) => (
                  <div key={member_code} className="d-flex gap-2">
                    <strong>
                      会員番号{" "}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`/admin/student/details/${member_id}?action=update&key=tab2`}
                      >
                        {member_code}
                      </a>
                    </strong>
                    <span>{error}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {hasRescheduleAttendances && (
          <RescheduleAttendanceWarning
            rescheduleAttendances={rescheduleAttendances}
            onBack={onBack}
            showProceedButton={false}
          />
        )}

        {hasErrors && (
          <div className="alert alert-warning text-center mb-3" role="alert">
            <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            エラーを修正してから再度お試しください
          </div>
        )}

        <div className="d-flex gap-2 justify-content-center">
          <button className="btn btn-secondary" onClick={onBack}>
            戻る
          </button>
          <button
            className="btn btn-primary"
            onClick={() =>
              putRegularClassSchedulesMutation.mutate(updatePayload)
            }
            disabled={
              putRegularClassSchedulesMutation.isPending ||
              hasErrors ||
              hasRescheduleAttendances
            }
          >
            {putRegularClassSchedulesMutation.isPending
              ? "更新中..."
              : "更新する"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeTableUpdateConfirm;
